(() => {
  const iframeVideos = document.querySelectorAll("iframe[src*='//player.vimeo.com']");

  iframeVideos.forEach(ifame => {
    const outerWrap = document.createElement('div');
    outerWrap.classList.add('vimeo-iframe-wrap-outer');
    const wrap = document.createElement('div');
    wrap.classList.add('vimeo-iframe-wrap');
    ifame.insertAdjacentElement('afterend', outerWrap);
    outerWrap.appendChild(wrap);
    wrap.appendChild(ifame);
  })
})();
